import { render } from "./Puzzle.vue?vue&type=template&id=3f652378&scoped=true"
import script from "./Puzzle.vue?vue&type=script&lang=js"
export * from "./Puzzle.vue?vue&type=script&lang=js"

import "./Puzzle.vue?vue&type=style&index=0&id=3f652378&scoped=true&lang=css"

import exportComponent from "D:\\Xoan\\asp-user\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f652378"]])

export default __exports__